import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { BrowserRouter } from 'react-router-dom';
import { LanguageProvider } from './LanguageProvider';
import CustomCursor from './components/CustomCursor';
import Titlebar from './windows/TitleBar';

const root = ReactDOM.createRoot(document.getElementById('root'));
const isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
root.render(
  <React.StrictMode>
    <BrowserRouter>
      <LanguageProvider>
        {/*<CustomCursor/>*/}
        {(window.__TAURI_INTERNALS__ && !isMobile) && <Titlebar />}
        <App />
      </LanguageProvider>
    </BrowserRouter>
  </React.StrictMode>
);

reportWebVitals();
